import Vue from 'vue'

const ReportEvents = new Vue();

export default ReportEvents;